import React from "react";
import CommonModal from "../../../../Settings/components/ResetContext/components/DumpModal";
import { CircularProgress } from "@mui/material";

const DeleteTaskModal = ({
  isOpen,
  isScheduledTask,
  loading,
  onClose,
  onConfirm,
}) => {
  const [input, setInput] = React.useState("");
  return (
    <CommonModal
      isOpen={isOpen}
      onClose={onClose}
      title={
        <p className="font-bold text-[18px] text-center text-[#4a4a4a]">
          Delete Tasks
        </p>
      }
      showAlert={false}
    >
      <div className="scrollable-modal-content !p-0">
        <p className="bg-[#fff0f0] border !border-[#ffcccc] text-[#000] p-4 rounded mb-6 text-center font-[600]">
          <span className="mr-3">⚠️</span>{" "}
          <span>
            You're about to delete this task. This action is permanent and
            cannot be undone.
          </span>
        </p>
        <div>
          <p className="mb-2 text-[14px] text-[#4a4a4a]">
            Type <span className="font-[600]">DELETE</span> to proceed
          </p>
          <input
            type="text"
            className="!p-2 outline-none border !border-[#ccc] rounded mb-3"
            placeholder="Type DELETE to proceed"
            value={input}
            onChange={(e) => setInput(e.target.value)}
          />
        </div>
        <div className="w-full flex gap-4">
          <button
            type="button"
            className="border w-full !border-[#dc3545] text-[#dc3545] px-4 py-2 rounded bg-[#f5c2c7] transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
            disabled={input !== "DELETE" || loading}
            onClick={onConfirm}
          >
            {loading ? <CircularProgress size={20} /> : "Delete Tasks"}
          </button>
        </div>
      </div>
    </CommonModal>
  );
};

export default DeleteTaskModal;
